import { Moment } from 'moment';

export enum QuestResponseType {
  PDF = 'PDF',
  CSV = 'CSV',
}

export enum QuotationReportType {
  itemPerSuppliers = 'ItemPerSuppliers',
  supplierPerItems = 'SupplierPerItems',
  vehiclePerQuotation = 'VehiclePerQuotation',
  workOrderPerQuotation = 'WorkOrderPerQuotation',
}

export enum QuotationSituationFilter {
  configuring = 'domain.enum.quotation_status.configuring',
  awaitingOffers = 'domain.enum.quotation_status.awaiting_offers',
  answered = 'domain.enum.quotation_status.answered',
  winnersSelected = 'domain.enum.quotation_status.winners_selected',
  done = 'domain.enum.quotation_status.done',
}

export interface QuestReportQuotationRequest {
  responseType: QuestResponseType;
  companiesIds?: string;
  reportType: QuotationReportType;
  situationFilter: QuotationSituationFilter[];
  orderBySmallerPrice?: boolean;
  supplierIds?: string;
  vehicleIds?: string;
  startDate: string;
  endDate: string;
}

export interface QuestQuotationReportFormValues {
  companiesIds?: number[];
  reportType: QuotationReportType;
  situationFilter: QuotationSituationFilter[];
  orderBySmallerPrice?: boolean;
  supplierIds?: number[];
  vehicleIds?: number[];
  initialDate: Moment;
  finalDate: Moment;
}
